@let showAddCompany = showAddCompanyButton;
@let showAddUser = showAddUserButton();
@let isCreateMode = mode() === computerAuthorizationModalMode.Create;
@let isEditMode = mode() === computerAuthorizationModalMode.Edit;

<mbs-modal
  #modal
  [loading]="loading()"
  [title]="'shared:computers.authorizeComputers' | i18next">
  <ng-container modal-body>
    @if (isGroupOperation) {
      <mbs-alert
        [icon]="true"
        [type]="alertType.info">
        {{ authorizeComputersAlertText$ | async }}
      </mbs-alert>
    }
    <form
      class="mbs-form_content"
      [formGroup]="modalForm">
      <mbs-select
        bindLabel="name"
        formControlName="company"
        [appendTo]="'.modal-content'"
        [clearable]="false"
        [items]="companies()"
        [label]="'common.company' | i18next: { format: 'title' }"
        [placeholder]="
          (showAddCompany ? 'shared:computers.selectCompanyInputPlaceHolder' : 'shared:computers.selectCompanyInputShortPlaceHolder')
            | i18next
        "
        [searchable]="true"
        [showRequiredMark]="false">
        <!-- Admin can create a company only if he has the permissions, as well as the permissions to create a user,
          otherwise creating a company in this case does not make sense -->
        @if (showAddCompany) {
          <ng-template #mbsSelectFooterTmp>
            <mbs-button
              [isCtrl]="true"
              (click)="onAddCompanyButtonClick()"
              >{{ 'shared:computers.addNewCompany' | i18next }}</mbs-button
            >
          </ng-template>
        }
      </mbs-select>

      @if (isAssignLicenseApplicable()) {
        <mbs-select-license-form-extended
          class="mt-4 d-block"
          [administratorMode]="administratorMode()"
          [companyId]="modalForm.value?.company?.id"
          [computer]="computer"
          [form]="selectLicenseForm"
          [kind]="licenseKind"
          [userId]="modalForm.value?.user?.id"></mbs-select-license-form-extended>
      }
      @if (showRMMPECEAlert()) {
        <mbs-alert
          class="mt-3 mb-0"
          [icon]="true"
          [type]="alertType.danger">
          {{ 'shared:licenses.rmmPECEAssignLimitAlert' | i18next }}
        </mbs-alert>
      }

      @if (showAssignUserManually()) {
        <mbs-checkbox
          class="mt-4 mb-4"
          formControlName="assignUserManually"
          [disabledSelf]="!modalForm.value.company"
          [label]="'shared:computers.assignUserManually' | i18next"></mbs-checkbox>
      }

      @if (assignUserManually.value) {
        @if (isCreateMode) {
          <mbs-alert
            [icon]="true"
            [type]="alertType.warning">
            {{ 'shared:computers.assignUserManuallyAlertText' | i18next }}
          </mbs-alert>
        }

        <div [class.mt-3]="isEditMode">
          <mbs-select
            bindLabel="email"
            formControlName="user"
            [appendTo]="'.modal-content'"
            [clearable]="false"
            [disabledSelf]="!modalForm.value.company"
            [items]="selectedCompanyUsers()"
            [label]="'common.user' | i18next: { format: 'title' }"
            [placeholder]="
              (showAddUser ? 'shared:computers.selectUserInputPlaceHolder' : 'shared:computers.selectUserInputShortPlaceHolder') | i18next
            "
            [searchable]="true"
            [showRequiredMark]="false">
            @if (showAddUser) {
              <ng-template #mbsSelectFooterTmp>
                <mbs-button
                  [isCtrl]="true"
                  (click)="onAddUserButtonClick()"
                  >{{ 'shared:computers.addNewUser' | i18next }}</mbs-button
                >
              </ng-template>
            }
          </mbs-select>
        </div>
      }
    </form>
  </ng-container>

  <ng-container modalFooter>
    <mbs-button
      type="primary"
      [disabled]="!formsAreValid()"
      [loading]="requestInProgress()"
      (click)="onSaveButtonClick()">
      {{ 'shared:buttons.save' | i18next }}
    </mbs-button>
    <mbs-button
      type="secondary"
      (click)="modal.close()">
      {{ 'shared:buttons.cancel' | i18next }}
    </mbs-button>
  </ng-container>
</mbs-modal>
